<script>
  import PandaIcon from "./icons/PandaIcon.svelte";
  import { ALL, RADICAL } from "./constants.js";
  import { extractLevelsText } from "./helpers.js";
  export let type;
  export let levels = [];

  $: getClassName = size => {
    return `${size}-${type}`;
  };

  let formatted = "";

  $: formatType = () => {
    if (type === RADICAL) {
      formatted = "radicals";
    } else if (type === ALL) {
      formatted = "everything";
    } else {
      formatted = type;
    }

    return formatted[0].toUpperCase() + formatted.substring(1);
  };

  $: levelText = () => {
    if (levels.length > 1) {
      return `Levels ${extractLevelsText(levels)}`;
    }
    return `Level ${levels}`;
  };
</script>

<style>
  .loading {
    font-size: 2rem;
    font-family: "Gayathri", sans-serif;
    font-weight: 300;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: calc(50vh);
  }

  .panda-cage {
    min-height: 115px;
  }

  .big-radical {
    color: var(--blue);
    font-size: 5rem;
    text-shadow: 2px 3px var(--blue-text-shadow);
    word-break: break-word;
  }

  .medium-radical {
    color: var(--blue);
    font-size: 3rem;
    text-shadow: 1px 2px var(--blue-text-shadow);
  }

  .small-radical {
    color: var(--blue);
    font-size: 1.4rem;
    text-shadow: 1px 1px var(--blue-text-shadow);
  }

  .big-kanji {
    color: var(--pink);
    font-size: 5rem;
    text-shadow: 2px 3px var(--pink-text-shadow);
    word-break: break-word;
  }

  .medium-kanji {
    color: var(--pink);
    font-size: 3rem;
    text-shadow: 1px 2px var(--pink-text-shadow);
  }

  .small-kanji {
    color: var(--pink);
    font-size: 1.4rem;
    text-shadow: 1px 1px var(--pink-text-shadow);
  }

  .big-vocabulary {
    color: var(--purple);
    font-size: 5rem;
    text-shadow: 2px 3px var(--purple-text-shadow);
    word-break: break-word;
  }

  .medium-vocabulary {
    color: var(--purple);
    font-size: 3rem;
    text-shadow: 1px 2px var(--purple-text-shadow);
  }

  .small-vocabulary {
    color: var(--purple);
    font-size: 1.4rem;
    text-shadow: 1px 1px var(--purple-text-shadow);
  }

  .big-all {
    color: var(--black);
    font-size: 5rem;
    text-shadow: 2px 3px var(--black-text-shadow);
    word-break: break-word;
  }

  .medium-all {
    color: var(--black);
    font-size: 3rem;
    text-shadow: 1px 2px var(--black-text-shadow);
  }

  .small-all {
    color: var(--black);
    font-size: 1.4rem;
    text-shadow: 1px 1px var(--black-text-shadow);
  }
</style>

<div class="loading">
  <div class="panda-cage">
    <div class="panda-san">
      <PandaIcon className={'loading-panda'} />
    </div>
  </div>
  <div class={getClassName('medium')} style={'margin-bottom: 1rem;'}>
    Panda-San is loading up your subjects
  </div>
  {#if levels.length}
    <div class={getClassName('small')} style={'margin: 0.5rem;'}>From</div>
    <div class={getClassName('big')}>{levelText()}</div>
  {/if}
</div>
